export default __webpack_public_path__ + "static/media/3.2bbc6a28.jpg";